import React, { useEffect, useState } from "react";
import axios from "axios";
import { Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./pages/homepage/HomePage";
import ServicesPage from "./pages/services/ServicesPage";
import "./i18n";
import InteractiveMap from "./pages/InteractiveMap/InteractiveMap";
import Mainpagelayout from "./layout/mainsitelayout/mainpagelayout";
import NewCaseDashboardPage from "./dashboard/pages/dashboardnewcase/NewCaseDashboardPage";
import DashboardPageLayout from "./layout/dashboardlayout/dashboardlayout";
import DevelopmentNewCase from "./dashboard/pages/DocumentUploadPage/DevelopmentNewCase";
import NewsPage from "./pages/NewsPage/NewsPage";
import CaseInsideTable from "./components/CaseInsideTable/CaseInsideTable";
import Structure from "./pages/Structure/Structure";
import DashboardHome from "./dashboard/pages/DashboardRegistery/DashboardHome";
import DashboardMap from "./dashboard/pages/DashboardRegistery/DashboardMap";
import AnswersInsidePage from "./pages/AnswersInsidePage/AnswersInsidePage";
import QAAccordion from "./components/qaaacordion/QAAccordion";
import UserPage from "./dashboard/pages/userPage/UserPage";
import DashboardApplicationComponent
    from "./dashboard/pages/dashboardapplicationcomponent/DashboardApplicationComponent";
import PageManagerPage from "./dashboard/pages/dashboardtablepage/PageManagerPage";
import PageFetcher from "./dashboard/components/PageFetcher/PageFetcher";
import BackToTopButton from "./components/BackToTopButton/BackToTopButton";
import EmployeeManagerPage from "./dashboard/pages/dashboardtablepage/EmployeeManagerPage";
import NewsManagerPage from "./dashboard/pages/dashboardtablepage/NewsManagerPage";
import ToUserCaseTablePage from "./dashboard/pages/dashboardtablepage/ToUserCaseTablePage";
import MainPageManagerPage from "./dashboard/pages/dashboardtablepage/MainPageManagerPage";
import StructurePageManagerPage from "./dashboard/pages/dashboardtablepage/StructurePageManagerPage";
import AddPartnerFormPage from "./dashboard/pages/dashboardtablepage/AddPartnerFormPage";
import HolidayPickerPage from "./dashboard/pages/dashboardtablepage/HolidayPickerPage";
import FaqPage from "./dashboard/pages/dashboardtablepage/FaqPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import { AuthProvider } from "./AuthProvider";
import ProtectedRoute from "./ProtectedRoute";
import AddEuroDocumentFormPage from "./dashboard/pages/dashboardtablepage/AddEuroDocumentFormPage";
import AddNewPermitDocPage from "./dashboard/pages/dashboardtablepage/AddNewPermitTypePage";
import AddNewFileTypeFormPage from "./dashboard/pages/dashboardtablepage/AddNewFileTypeFormPage";
import RegionControllerPage from "./dashboard/pages/dashboardtablepage/RegionControllerPage";
import AdminRegistrationPage from "./dashboard/pages/dashboardtablepage/AdminRegistrationPage";
import DocumentList from "./pages/europe/DocumentList";
import ResetPassword from "./pages/ForgetPassword/ResetPassword";
import SettingsPage from "./dashboard/pages/dashboardtablepage/SettingsPage";
import LoginForPermitRegistration from "./components/popuplogin/LoginForPermitRegistration";
import SharedFilesList from "./pages/AnswersInsidePage/SharedFilesList";
import ExternalTable from "./pages/AnswersOfAgency/ExternalTable";
import NewDocTypePage from "./dashboard/pages/dashboardtablepage/NewDocTypePage";
import RewriteRequestPage from "./dashboard/pages/dashboardtablepage/RewriteRequestPage";
import DynamicInputPage from "./dashboard/pages/dashboardtablepage/DynamicInputPage";
import GlobalInputFields from "./dashboard/pages/dashboardtablepage/GlobalInputFields";
import "./App.css"
import ActivationPage from "./pages/ForgetPassword/ActivationPage";
import AdminCaseUserPage from "./dashboard/pages/dashboardtablepage/AdminCaseUserPage";
import DocumentUploaderPage from "./dashboard/pages/dashboardtablepage/DocumentUploaderPage";
import NewsPageId from "./pages/NewsPage/NewsPageId";
import DashboardApplicationComponentForExpert
    from "./dashboard/pages/dashboardapplicationcomponent/DashboardApplicationComponentForExpert";
import DashboardTablePage from "./dashboard/pages/dashboardtablepage/ObjectRegisteryRegistration";
import DevelopmentNewCaseExpert from "./dashboard/pages/DocumentUploadPage/DevelopmentNewCaseExpert";
import NoPermission from "./pages/NotFoundPage/NoPermission";
import { CircularProgress, Typography } from "@mui/material";
import SuccessPage from "./pages/NotFoundPage/SuccessPage";
import CreateExpCaseComponent from "./dashboard/components/OldObjects/CreateExpCaseComponent";
import InsectFilesPage from "./dashboard/pages/dashboardtablepage/InsectFilesPage";
import OldObjectsPage from "./dashboard/pages/dashboardtablepage/OldObjectsPage";
import PDFHealth from "./dashboard/pages/dashboardtablepage/PDFHealth";
import DocumentsPage from "./dashboard/pages/dashboardtablepage/DocumentsPage";
import NomenclatureChangePage from "./dashboard/pages/dashboardtablepage/NomenclatureChangePage";
import NewsEditPage from "./dashboard/pages/dashboardtablepage/NewsEditPage";


function App() {
    const [geoIds, setGeoIds] = useState({
        regionId: null,
        municipalityId: null,
        councilId: null,
        cityId: null
    });
    const isMobile = window.innerWidth < 768;
    const location = useLocation();
    const [hasClicked, setHasClicked] = useState(0);



    useEffect(() => {
        window.scrollTo(0, 0);
        document.querySelectorAll('.header').forEach(el => el.style.display = '')
        document.querySelectorAll('.footer-container').forEach(el => el.style.display = '')
        document.querySelectorAll('.sidebar-dashboard').forEach(el => el.style.display = '')

        if (location.pathname === "/interactivemap") {
            document.body.className = `route-${location.pathname.replace('/', '') || 'interactivemap'}`;
        } else {
            document.body.className = `route-${location.pathname.replace('/', '') || 'root'}`;
        }
    }, [location]);


    useEffect(() => {
        if (location.pathname === "/") {
            document.title = "ტექნიკური და სამშენებლო ზედამხედველობის სააგენტო";
        }
        if (location.pathname.includes("map")) {
            document.title = "ინტერაქტიული რუკა";
        } else if (location.pathname.includes("/dashboard/registerydocs")) {
            document.title = "უწყებრივი რეესტრის დოკუმენტები";
        } else if (location.pathname.includes("/dashboard/casenotifications")) {
            document.title = "ახალი შეტყობინებები";
        } else if (location.pathname.includes("/dashboard/newcases")) {
            document.title = "ახალი შეტყობინებები";
        } else if (location.pathname.includes("/dashboard/activecases")) {
            document.title = "ჩემი მიმდინარე განაცხადები";
        } else if (location.pathname.includes("/dashboard/manageractivecases")) {
            document.title = "ჩემი მიმდინარე განაცხადები";
        } else if (location.pathname.includes("/dashboard/currentcases")) {
            document.title = "მიმდინარე ადმინისტრაციული წარმოება";
        } else if (location.pathname.includes("/dashboard/mydeclinedcases")) {
            document.title = "ჩემი დახარვეზებული განაცხადები";
        } else if (location.pathname.includes("/dashboard/declinedcases")) {
            document.title = "დახარვეზებული განაცხადები";
        } else if (location.pathname.includes("/dashboard/finishedcases")) {
            document.title = "დასრულებული ადმინისტრაციული წარმოება";
        } else if (location.pathname.includes("/dashboard/expiring")) {
            document.title = "გასდის ნებართვის/პირობის ვადა";
        } else if (location.pathname.includes("/dashboard/delayedcases")) {
            document.title = "ვადაგადაცილებული";
        } else if (location.pathname.includes("/dashboard/historycases")) {
            document.title = "ისტორია";
        } else if (location.pathname.includes("registery")) {
            document.title = "უწყებრივი რეესტრი";
        } else if (location.pathname.includes("objectregistry")) {
            document.title = "უწყებრივი რეესტრი";
        } else if (location.pathname === "/services" || location.pathname === "dashboard/services") {
            document.title = "სერვისები";
        } else if (location.pathname.includes("oldobjects")) {
            document.title = "ძველი უწყებრივი რეესტრი";
        } else if (location.pathname.includes("dashboard/objectregistration")) {
            document.title = "უწყებრივ რეესტრში ობიექტის რეგისტრაცია";
        } else if (location.pathname.includes("agencyanswers")) {
            document.title = "სააგენტოს პასუხები";
        } else if (location.pathname.includes("/dashboard/profile")) {
            document.title = "ჩემი ანგარიში";
        } else if (location.pathname.includes("/dashboard/home")) {
            document.title = "პორტალის მთავარი გვერდი";
        } else if (location.pathname.includes("/pages/structure")) {
            document.title = "სტრუქტურა";
        } else if (location.pathname.includes("news")) {
            document.title = "სიახლეები";
        } else if (location.pathname !== "/dashboard/mycases/casemanager") {
            document.title = "ტექნიკური და სამშენებლო ზედამხედველობის სააგენტო";
        }
    }, [location]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryTypes`);
                if (response.data.success) {
                    extractIds(response.data.data);
                }
            } catch (error) {
            }
        };

        const extractIds = (data) => {
            const idMap = {
                'რეგიონი': 'regionId',
                'მუნიციპალიტეტი': 'municipalityId',
                'საკრებულო': 'councilId',
                'ქალაქი': 'cityId'
            };
            let newIds = { ...geoIds };
            data.forEach(item => {
                const key = idMap[item.typesName];
                if (key) {
                    newIds[key] = item.id;
                }
            });
            setGeoIds(newIds);
        };
        void fetchData();
    }, []);



    const hideFooterRoutes = ['/interactivemap'];
    return (
        <AuthProvider>
            <div className="App">
                {!location.pathname.includes("newcase") && isMobile && (
                    <BackToTopButton />
                )}

                {geoIds.cityId === null ? (
                    <div
                        className={"initial-loader-container"}
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/headerdata/tacsa_logo.svg"}
                            alt="Tacsa Logo"
                            className="pulse-logo"
                        />
                        <Typography
                            sx={{
                                fontSize: 20,
                                fontWeight: 'bold',
                                color: 'rgba(255, 255, 255, 0.9)',
                                mb: 3,
                            }}
                        >
                            პორტალი იტვირთება...
                        </Typography>
                        <CircularProgress sx={{ color: 'rgba(255, 255, 255, 0.8)' }} />
                    </div>
                ) : (
                    <Routes>
                        <Route path="/"
                            element={<Mainpagelayout hideFooter={hideFooterRoutes.includes(location.pathname)} />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/services" element={<ServicesPage />} />
                            <Route path="/interactivemap" element={<InteractiveMap />} />
                            <Route path="/agencyanswers" element={<ExternalTable />} />
                            <Route path="/objectregistry" element={<ExternalTable />} />
                            <Route path="/ForgetPassword" element={<ResetPassword />} />
                            <Route path="/activatenewuser" element={<ActivationPage />} />
                            <Route path="/sharedfiles" element={<SharedFilesList />} />
                            <Route path="/news/:page" element={<NewsPage />} />
                            <Route path="/news" element={<NewsPage />} />
                            <Route path="/caseinfo" element={<AnswersInsidePage />} />
                            <Route path="/qa" element={<QAAccordion />} />
                            <Route path="/pages/structure" element={<Structure />} />
                            <Route path="/pages/news" element={<NewsPage />} />
                            <Route path="/pages/:pageName" element={<PageFetcher />} />
                            <Route path="/new/:id" element={<NewsPageId />} />
                            <Route path="/pages/euintegration" element={<DocumentList />} />
                            <Route path="/login" element={<LoginForPermitRegistration />} />
                            <Route path="/success" element={<SuccessPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>
                        <Route path="/dashboard" element={<ProtectedRoute><DashboardPageLayout /></ProtectedRoute>}>
                            <Route path="/dashboard" element={<NewCaseDashboardPage />} />
                            <Route path="/dashboard/home" element={<DashboardHome />} />
                            <Route path="/dashboard/oldobjects" element={<OldObjectsPage />} />
                            <Route path="/dashboard/createexpercase"
                                element={<CreateExpCaseComponent geoIds={geoIds} />} />
                            <Route path="/dashboard/services" element={<NewCaseDashboardPage />} />
                            <Route path="/dashboard/newcases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/activecases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/casenotifications" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/manageractivecases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/currentcases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/mydeclinedcases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/declinedcases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/finishedcases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/delayedcases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/expiring" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/permitdoc" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/historycases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/lastusercases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/secretdocuments" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/agencyanswers" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/waitingToSign" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/docsToSign" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/expfiles" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/registerydocs" element={<InsectFilesPage geoIds={geoIds} />} />
                            <Route path="/dashboard/objectregistrationtable" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/managertable" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/registery" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/hidecases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/myfinishedcases" element={<ToUserCaseTablePage />} />
                            <Route path="/dashboard/mycases/casemanager" element={<CaseInsideTable geoIds={geoIds} />} />
                            <Route path="/dashboard/newcase"
                                element={<DashboardApplicationComponent geoIds={geoIds} />} />
                            <Route path="/dashboard/newcaseexpert"
                                element={<DashboardApplicationComponentForExpert geoIds={geoIds} />} />
                            <Route path="/dashboard/managertable/casemanager"
                                element={<CaseInsideTable geoIds={geoIds} />} />
                            <Route path="/dashboard/nopermistion" element={<NoPermission />} />
                            <Route path="/dashboard/*" element={<NotFoundPage />} />
                            <Route path="/dashboard/map" element={<DashboardMap />} />
                            <Route path="/dashboard/profile" element={<UserPage />} />
                            <Route path="/dashboard/objectregistration" element={<DashboardTablePage />} />
                            <Route path="/dashboard/newcase/uploadfiles"
                                   element={<DevelopmentNewCase geoIds={geoIds}/>}/>
                            <Route path="/dashboard/newcase/uploadfilesexpert" element={<DevelopmentNewCaseExpert/>}/>
                            <Route path="/dashboard/dictionary" element={<RegionControllerPage geoIds={geoIds}/>}/>
                            <Route path="/dashboard/addnewdoc" element={<AddNewFileTypeFormPage geoIds={geoIds}/>}/>
                            <Route path="/dashboard/pagemanager" element={<PageManagerPage/>}/>
                            <Route path="/dashboard/employeemanager" element={<EmployeeManagerPage/>}/>
                            <Route path="/dashboard/newsmanager" element={<NewsManagerPage/>}/>
                            <Route path="/dashboard/editnews/:id" element={<NewsEditPage/>}/>
                            <Route path="/dashboard/mainpagemanager" element={<MainPageManagerPage/>}/>
                            <Route path="/dashboard/StructurePageManager" element={<StructurePageManagerPage/>}/>
                            <Route path="/dashboard/partnermanager" element={<AddPartnerFormPage/>}/>
                            <Route path="/dashboard/holiday" element={<HolidayPickerPage/>}/>
                            <Route path="/dashboard/faqmanager" element={<FaqPage/>}/>
                            <Route path="/dashboard/eurointegrationmanager" element={<AddEuroDocumentFormPage/>}/>
                            <Route path="/dashboard/addnewpermitfile" element={<AddNewPermitDocPage/>}/>
                            <Route path="/dashboard/adminregistration" element={<AdminRegistrationPage/>}/>
                            <Route path="/dashboard/settings" element={<SettingsPage/>}/>
                            <Route path="/dashboard/documents" element={<DocumentsPage geoIds={geoIds}/>}/>
                            <Route path="/dashboard/inputfieldsglobal" element={<DynamicInputPage/>}/>
                            <Route path="/dashboard/globalinputfields" element={<GlobalInputFields/>}/>
                            <Route path="/dashboard/newdoctypes" element={<NewDocTypePage/>}/>
                            <Route path="/dashboard/rewrite" element={<RewriteRequestPage hasClicked={hasClicked} setHasClicked={setHasClicked}/>}/>
                            <Route path="/dashboard/admincases" element={<ToUserCaseTablePage/>}/>
                            <Route path="/dashboard/filedrive" element={<DocumentUploaderPage/>}/>
                            <Route path="/dashboard/admincaseedit" element={<AdminCaseUserPage/>}/>
                            <Route path="/dashboard/changenomenclature" element={<NomenclatureChangePage/>}/>
                            <Route path="/dashboard/pdf" element={<PDFHealth/>}/>
                        </Route>
                    </Routes>
                )}
            </div>
        </AuthProvider>

    );
}

export default App;
